<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin/articles']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
      <h2>Liste des souscriptions</h2>
    </div>

    <div class="add-search-form">
      <div class="add-form" (click)="addForm()" (keypress)="addForm()" appChangeColorTheme [isHover]="true">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
          <span>Nouvelle souscription</span>
      </div>
      <div class="add-form" (click)="exportSubscriptions()" (keypress)="exportSubscriptions()" appChangeColorTheme [isHover]="true">
          <fa-icon [icon]="getFaIcon('faUpload')" appChangeColorTheme attribute="color"></fa-icon>
          <span>Exporter les souscriptions</span>
      </div>
      <div class="search_bar">
        <form [formGroup]="searchForm">
            <input id="" type="text" placeholder="Chercher une souscription ..." (input)="applyFilter($event.target.value)" formControlName="keyword">
        </form>
        <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" (keypress)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
        <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput" ></fa-icon>
      </div>
    </div>
  </div>

  <div class="content" [hidden]="isLoading">
      <div class="list-forms-subscription mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn" class="cell_club">Créé le</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.createdOn | date:'dd/MM/yyyy'}} </td>
          </ng-container>

          <ng-container matColumnDef="articleKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="articleKey" class="cell_club">N° de l'article</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.articleKey}} </td>
          </ng-container>

          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="username" class="cell_club">Nom et prénom</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.username}} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="cell_club">Email</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.email}} </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="city" class="cell_club">Ville</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.city}} </td>
          </ng-container>

          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber" class="cell_club">N° de téléphone</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.phoneNumber}} </td>
          </ng-container>

          <ng-container matColumnDef="participantCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="participantCount" class="cell_club">Nombre de participants</th>
            <td mat-cell *matCellDef="let element" class="cell_club"> {{element.participantCount}} </td>
          </ng-container>

          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef class="cell_action"></th>
            <td mat-cell *matCellDef="let element" class="cell_action">
              <div class="actions">
                <button mat-icon-button (click)="edit(element)" matTooltip="Éditer" matTooltipPosition="above">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteFS(element)" matTooltip="Supprimer" matTooltipPosition="above">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <ng-container *ngIf="subscriptions.length > 0">
        <div class="pageTotal"></div>
      </ng-container>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
  </div>
</div>
